import {FC} from 'react';
import {StyledFooterExternalLink} from '@/components/footer/FooterGroup.styles';
import {Box} from '@mui/material';
import {NavigateToIcon} from '@/components/ui/icons/NavigateTo';
import {FooterLinkWithLinkAndLabel} from '@/components/footer/FooterGroup';

type FooterExternalLinkProps = {
    link: FooterLinkWithLinkAndLabel
}

export const FooterExternalLink: FC<FooterExternalLinkProps> = ({
  link
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5}}>
      <StyledFooterExternalLink target='_blank' rel='noopener noreferrer' href={link.link}>{link.label}</StyledFooterExternalLink>
      <NavigateToIcon/>
    </Box>
  )
}